export class GoogleNormalisedAddress {
    public country: string;
    public country_short: string;
    public administrative_area_level_1: string;
    public administrative_area_level_1_short: string;
    public administrative_area_level_2: string;
    public administrative_area_level_2_short: string;
    public locality: string;
    public locality_short: string;
    public postal_code: string;
    public postal_code_short: string;
}
